import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const HistoryPagination = ({ page, setPage, totalPages }) => {
  if (totalPages <= 1) return null;

  return (
    <div className="px-4 sm:px-6 py-4 flex justify-center items-center gap-2 border-t border-gray-100">
      <button 
        onClick={() => setPage(Math.max(0, page - 1))}
        disabled={page === 0}
        className="p-2 rounded-md hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed text-gray-500"
      >
        <ChevronLeft size={18} />
      </button>
      
      <span className="text-[13px] font-medium text-gray-700 mx-4">
        Страница {page + 1} от {totalPages}
      </span>

      <button 
        onClick={() => setPage(Math.min(totalPages - 1, page + 1))}
        disabled={page === totalPages - 1}
        className="p-2 rounded-md hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed text-gray-500"
      >
        <ChevronRight size={18} />
      </button>
    </div>
  );
};

export default HistoryPagination;
